import { BadgeType, Product } from '@acorn-portal/shared/src/services/interface/Shared';
import { NON_BUSINESS_VEHICLE_CODES } from './constants';

/**
 * Determines if a vehicle usage code indicates business use
 */
export const isUsedForBusiness = (vehicleUse: string) => {
	return !NON_BUSINESS_VEHICLE_CODES.includes(vehicleUse);
};

/**
 * Checks if a product is a telematics product
 */
export function isTelematics(product: Product): boolean {
	const isTelematics: boolean = product === Product.TELEMATICS || product === Product.CARROT;
	return isTelematics;
}

/**
 * Determines if complex renewal should be bypassed for a product
 */
export function bypassComplexRenewal(product: Product | undefined): boolean {
	const env = (globalThis as any).import?.meta?.env ?? {};
	const globalBypass = env.VITE_BYPASS_COMPLEX_RENEWALS === 'true';

	if (product === undefined) {
		return globalBypass;
	}

	const specificKey = `VITE_BYPASS_COMPLEX_RENEWALS_${product}`;
	const specificBypass = env[specificKey];

	if (specificBypass === 'true') {
		return true;
	}
	if (specificBypass === 'false') {
		return globalBypass;
	}
	return globalBypass;
}

/**
 * Checks if a product/scheme combination is Protect Young Driver
 */
export function isProtectYD(product: Product, scheme: string): boolean {
	const isProtectYD: boolean =
		(product === Product.TELEMATICS && scheme === 'AcornProtectYD') ||
		(product === Product.CARROT && scheme === 'CarrotYD') ||
		(product === Product.TELEMATICS && scheme === 'MyPolicyYD');
	return isProtectYD;
}

/**
 * Checks if a product/scheme combination is Protect (adult driver)
 */
export function isProtect(product: Product, scheme: string): boolean {
	const isProtect: boolean =
		(product === Product.TELEMATICS && scheme === 'AcornProtect') ||
		(product === Product.CARROT && scheme === 'CarrotTD') ||
		(product === Product.TELEMATICS && scheme === 'MyPolicyTD');
	return isProtect;
}

/**
 * Checks if a driver can drive a specific vehicle based on usage types
 */
export function canDriveVehicle(driversUsage: string, vehicleUsage: string): boolean {
	const publicDriver = driversUsage == BadgeType.PUBLIC_HIRE;
	const privateVehicle = vehicleUsage == BadgeType.PRIVATE_HIRE;
	const mismatchedUsage = publicDriver && privateVehicle;
	return !mismatchedUsage;
}
